var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-error"},[_vm._v(" Something went wrong please try again later ")])
}
var staticRenderFns = []

export { render, staticRenderFns }